import { API } from "./api";

export const getAllVehicleTypes = () => API.get(`/vehicleType`);

export const createVehicleType = (vehicle) => API.post(`/vehicleType`, vehicle);

export const deleteVehicleType = (vehicleId) =>
  API.delete(`/vehicleType/${vehicleId}`);

export const updateVehicleType = (id, vehicles) =>
  API.put(`vehicleType/${id}`, vehicles);
